// extracted by mini-css-extract-plugin
module.exports = {"controls":"MovementControls_controls__eKWqp","control":"MovementControls_control__368Ll","arrow":"MovementControls_arrow__yf_Bf"};